import {Injectable} from '@angular/core';
import {SubmittalFeedbackType} from '../../model';

@Injectable()
export class SubmittalFeedbackService {

  constructor() {
  }

  createSubmittalFeedback(feedbackList: SubmittalFeedbackBody[],
                          associatedId: string,
                          associatedType: SubmittalFeedbackType): SubmittalFeedbackBody {
    const existingFeedback = feedbackList.find(f => (
      f.associatedId === associatedId && f.associatedType === associatedType
    ));

    return {
      associatedType,
      associatedId,
      helpful: existingFeedback ? existingFeedback.helpful : null,
      comment: null,
      helpfulCount: existingFeedback ? existingFeedback.helpfulCount : 0
    };
  }

}
